import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {MewsConfig} from "crqlar-react-common/dist/models/integrations/mews/mews.config";
import {MewsTaskService} from "crqlar-react-common/dist/services/integrations/mews/mewsTask.service";
import {useTranslation} from "react-i18next";
import SyncTasksTable from "../../common/SyncTasksTable";

interface Props {
    configData: UseEntityData<MewsConfig>
}

const MewsTasks = ({configData}: Props) => {
    const {t} = useTranslation();
    const configId = configData.item.id;

    return (
        <SyncTasksTable
            configId={configId}
            tableId="system-mews-sync-tasks"
            list={MewsTaskService.getAll}
            actions={[
                {
                    id: 'btn-schedule-daily-sync',
                    label: t('Schedule daily sync'),
                    startIcon: <SyncIcon/>,
                    onClick: () => MewsTaskService.scheduleDailySync(configId!)
                },
                {
                    id: 'btn-schedule-full-sync',
                    label: t('Schedule full sync'),
                    startIcon: <AddIcon/>,
                    onClick: () => MewsTaskService.scheduleFullSync(configId!)
                }
            ]}
        />
    );
};

export default MewsTasks;
